import React, { useState, useEffect, useContext } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./styles/app.css";
import "./styles/global.css";
import DefaultLayout from "./layouts/DefaultLayout";
import AuthLayout from "./layouts/AuthLayout";
import getRoutes from "./routes/routes";
import EventThirdPage from "./pages/EventThirdPage/EventThirdPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import { LanguageContext } from "./utils/LanguageContext";
import LanguagesPage from "./pages/LanguagesPage/LanguagesPage";
import { TranslationsContext } from "./utils/TranslationsContext";
import Loader from "./components/Loader/Loader";
import EventPersonWrapper from "./pages/EventPersonWrapper/EventPersonWrapper";
import ForgottenPasswordPage from "./pages/ForgottenPasswordPage/ForgottenPasswordPage";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import { ViewerProvider, useViewer } from "./utils/ViewerContext";

const ThirdRoutes = ({ changeLanguage }) => {
  const { t } = useContext(TranslationsContext);
  const { role, isLoading } = useViewer();
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    if (isLoading) return;
    setRoutes(getRoutes(t, role));
  }, [t, role, isLoading]);

  if (!routes.length) return <Loader />;
  return (
    <div className="flex-direction-row app-container">
      <div className="flex-direction-column height-100 width-100">
        <Routes>
          {routes.map((route, index) => (
            <Route
              path={route.to}
              element={
                <ProtectedRoute>
                  <DefaultLayout setLanguage={changeLanguage}>
                    {route.element}
                  </DefaultLayout>
                </ProtectedRoute>
              }
              key={index}
            />
          ))}
          <Route
            path="/event/:id"
            element={
              <ProtectedRoute>
                <DefaultLayout setLanguage={changeLanguage}>
                  <EventPersonWrapper />
                </DefaultLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/events/:eventId/persons/:personId"
            element={
              <ProtectedRoute>
                <DefaultLayout setLanguage={changeLanguage}>
                  <EventPersonWrapper />
                </DefaultLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/login"
            element={
              <AuthLayout>
                <LoginPage />
              </AuthLayout>
            }
          />

          <Route
            path="/reset-password"
            element={
              <AuthLayout>
                <ForgottenPasswordPage />
              </AuthLayout>
            }
          />
          {/* Catch-all — any unmatched path (typo, stale/broken link) shows
              a 404 page instead of an empty screen or a silent redirect. */}
          <Route
            path="*"
            element={
              <AuthLayout>
                <NotFoundPage />
              </AuthLayout>
            }
          />
        </Routes>
      </div>
    </div>
  );
};

function ThirdApp() {
  const { language, changeLanguage } = useContext(LanguageContext);

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ViewerProvider>
        <ThirdRoutes changeLanguage={changeLanguage} />
      </ViewerProvider>
    </Router>
  );
}

export default ThirdApp;
